import React, { useEffect, useState } from "react";
import styles from "../../assets/scss/v0/CountDownTime.module.scss"
import Calendar from "./Calendar";

function CountDownTime() {
	const [timeLeft, setTimeLeft] = useState({
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0
	});

	const weddingDate = new Date("2025-03-23T23:59:59");

	useEffect(() => {
		const timer = setInterval(() => {
			const now = new Date().getTime();
			const difference = weddingDate.getTime() - now;

			const days = Math.floor(difference / (1000 * 60 * 60 * 24));
			const hours = String(Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2,'0');
			const minutes = String(Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))).padStart(2,'0');
			const seconds = String(Math.floor((difference % (1000 * 60)) / 1000)).padStart(2,'0');

			setTimeLeft({ days, hours, minutes, seconds });

			if (difference < 0) {
				clearInterval(timer);
				setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
			}
		}, 1000);

		return () => clearInterval(timer);
	}, [weddingDate]);

	return (
		<>
			<div
				className= {styles.container}
			>
				<div className={`${styles['containerCountDown']}`}>
					<div
						className={styles['title']}>CÙNG ĐẾM NGƯỢC THỜI GIAN</div>
					{/*<div className={styles['subtitle']}>Ngày Chung Đôi</div>*/}
					<div className={styles['countdown']}>
						<div className={styles['time-box']}>
							<span className={styles['number']}>{timeLeft.days}</span>
							<span className={styles['label']}>Ngày</span>
						</div>
						<div className={styles['time-box']}>
							<span className={styles['number']}>{timeLeft.hours}</span>
							<span className={styles['label']}>Giờ</span>
						</div>
						<div className={styles['time-box']}>
							<span className={styles['number']}>{timeLeft.minutes}</span>
							<span className={styles['label']}>Phút</span>
						</div>
						<div className={styles['time-box']}>
							<span className={styles['number']}>{timeLeft.seconds}</span>
							<span className={styles['label']}>Giây</span>
						</div>
					</div>
				</div>
				<Calendar weddingDate={weddingDate} className={styles.calendar}/>
			</div>
		</>
	)
}

export default CountDownTime;

